export default "__VITE_ASSET__df937434__"